import Auth from "./containers/Auth";

export default Auth;
